import { ColumnTable, Icon } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../../../locales/translations';
import { formatDate } from '../../../../../../utils/dates';
import { SurveyContext, surveyContextTexts } from '../../../types/Survey';
import { SurveyDraft } from '../../../types/SurveyDraft';

interface useColumnActions {
  onClickCopy: (row: any) => void;
  onClickEdit: (row: any) => void;
  onClickRemove: (row: any) => void;
}

export default function useColumns(
  props: useColumnActions,
): ColumnTable<SurveyDraft>[] {
  const { t } = useTranslation(TranslationsKeys.MANAGEMENT_TOOLS_SURVEY);
  const { onClickCopy, onClickEdit, onClickRemove } = props;

  return [
    {
      columnName: 'title',
      headerText: t('surveyList.headers.title'),
      tdClassName: 'text-left pl-5',
      thClassName: 'text-center',
    },
    {
      columnName: 'context',
      headerText: t('surveyList.headers.context'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: (options) =>
        options.row.context &&
        surveyContextTexts[options.row.context as SurveyContext],
    },
    {
      columnName: 'period',
      headerText: t('surveyList.headers.period'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: (options) => options.row.content.period.name,
    },
    {
      columnName: 'startDate',
      headerText: t('surveyList.headers.startDate'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: (options) => formatDate(options.row?.startDate, 'DD/MM/YYYY'),
    },
    {
      columnName: 'endDate',
      headerText: t('surveyList.headers.endDate'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: (options) => formatDate(options.row?.endDate, 'DD/MM/YYYY'),
    },
    {
      columnName: 'actions',
      headerText: t('surveyList.headers.actions'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: ({ row }) => {
        return (
          <div className="d-flex justify-content-end">
            <button className="btn" onClick={() => onClickCopy(row)}>
              <Icon color="primary" name="duplicate" />
            </button>

            <button className="btn" onClick={() => onClickEdit(row)}>
              <Icon color="primary" name="edit" />
            </button>

            <button className="btn" onClick={() => onClickRemove(row)}>
              <Icon name="trash" color="primary" />
            </button>
          </div>
        );
      },
    },
  ];
}
